import { render, staticRenderFns } from "./QuestionBlock.vue?vue&type=template&id=50ae1295&scoped=true"
import script from "./QuestionBlock.vue?vue&type=script&lang=js"
export * from "./QuestionBlock.vue?vue&type=script&lang=js"
import style0 from "./QuestionBlock.vue?vue&type=style&index=0&id=50ae1295&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50ae1295",
  null
  
)

export default component.exports